import React, {ReactElement} from 'react';

function renderScriptTag(attributes: Record<string, string>): ReactElement {
  const ref = (span: HTMLSpanElement | null) => {
    const myScript = document.createElement('script');

    for (const attributeName in attributes) {
      if (attributes.hasOwnProperty(attributeName)) {
        myScript.setAttribute(attributeName, attributes[attributeName]);
      }
    }

    span?.appendChild(myScript);
  };

  return <span ref={ref}/>;
}

export function ShortcodesRenderer(data: {name: string; attributes: Record<string, string>}): ReactElement {
  switch (data.name) {
    case 'script': {
      return renderScriptTag(data.attributes);
    }
    default:
      return <React.Fragment/>;
  }
}
